import qs from "query-string";

class BaseModule {
  constructor() {
    this.$http = $http;
  }

  get(url, config = {}) {
    return this.$http.get(url, config);
  }

  post(url, data = undefined, config = {}) {
    return this.$http.post(url, data ? data : {}, config);
  }

  put(url, data = undefined, config = {}) {
    return this.$http.put(url, data, config);
  }

  delete(url, config = {}) {
    return this.$http.delete(url, config);
  }
}

let _env = "";
if (process.env.NODE_ENV == "local") {
  _env = "https://devwww.laoyaoba.com/api";
} else if (process.env.NODE_ENV == "development") {
  _env = "https://devwww.laoyaoba.com/api";
} else {
  _env = "https://www.laoyaoba.com/api";
}

const $http = axios.create({
  baseURL: _env,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded'
  },
  transformRequest: [
    function (data) {
      return qs.stringify(data);
    },
  ],
});

export default BaseModule;
